import React from 'react';
import { Fade, Snackbar, type SnackbarOrigin } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';

interface ToastProps {
  open: boolean;
  onClose: () => void;
  message: string;
  anchorOrigin?: SnackbarOrigin;
  sx?: SxProps<Theme>;
}

export const Toast: React.FC<ToastProps> = ({
  open,
  onClose,
  message = 'Toast Test',
  anchorOrigin = { vertical: 'top', horizontal: 'center' },
  sx = {},
}: ToastProps) =>
{
  return (
    <Snackbar
      open={open}
      message={message}
      anchorOrigin={anchorOrigin}
      slots={{ transition: Fade }}
      onClose={onClose}
      autoHideDuration={2500}
      sx={{
        '& .MuiSnackbarContent-root': {
          fontFamily: 'sans-serif',
          fontSize: '0.85rem',
          bgcolor: '#62accb',
          color: '#fff',
          padding: 0,
          textAlign: 'center',
          justifyContent: 'center',
          transform: 'translateY(40px)', //Position in screen
        },
        ...sx,
      }}
      slotProps={{
        transition: {
          timeout: {
            enter: 300,
            exit: 2500,
          },
        },
      }}
    />
  );
};
